import React, { Suspense } from 'react'
import { useSelector } from 'react-redux'
import {
   BrowserRouter as Router,
   Switch,
   Route,
   Redirect,
} from 'react-router-dom'
import { ToastContainer } from 'react-toastify'

import 'react-toastify/dist/ReactToastify.css'

import { Loader } from './components'

import {
   Home,
   Login,
   Register,
   DownloadKey,
   DashboardHome,
   RestoreAccount,
   Notifications,
   Apps,
   Settings,
   Artworks,
   Exchange,
} from './containers'

const Wallet = React.lazy(() => import('./containers/Wallet'))
const Coin = React.lazy(() => import('./containers/Coin'))
const Watchlist = React.lazy(() => import('./containers/Watchlist'))

const App = () => {
   const { isDarkTheme } = useSelector(state => state.theme)

   return (
      <Router>
         <Switch>
            <Suspense fallback={<Loader />}>
               <Route exact path="/" component={Home} />
               <Route exact path="/login" component={Login} />
               <Route exact path="/register" component={Register} />
               <Route
                  exact
                  path="/restore-account"
                  component={RestoreAccount}
               />
               <ProtectedRoute
                  exact
                  path="/download-key"
                  component={DownloadKey}
               />
               <ProtectedRoute exact path="/home" component={DashboardHome} />
               <ProtectedRoute
                  exact
                  path="/notifications"
                  component={Notifications}
               />
               <ProtectedRoute
                  exact
                  path="/notifications/:notificationId"
                  component={Notifications}
               />
               <ProtectedRoute exact path="/apps" component={Apps} />
               <ProtectedRoute exact path="/settings" component={Settings} />
               <ProtectedRoute exact path="/wallet/:tab?" component={Wallet} />
               <ProtectedRoute
                  exact
                  path="/artworks/:artworkId?"
                  component={Artworks}
               />
               <ProtectedRoute
                  exact
                  path="/coin/:coinId/:transactionId?"
                  component={Coin}
               />
               <ProtectedRoute exact path="/watchlist" component={Watchlist} />
               <ProtectedRoute exact path="/exchange" component={Exchange} />
               {/* <Redirect path="/" to="/" /> */}
            </Suspense>
         </Switch>
         <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={true}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            pauseOnHover
            className={isDarkTheme ? 'ToastDark' : undefined}
         />
      </Router>
   )
}

export default App

const ProtectedRoute = ({ component: Component, ...rest }) => {
   const { isAuthenticated } = useSelector(state => state.user)

   return (
      <Route
         {...rest}
         render={props =>
            isAuthenticated ? (
               <Component {...props} />
            ) : (
               <Redirect to="/login" />
            )
         }
      />
   )
}
